import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'tv2NewsState';

export const getNews = createAsyncThunk(
    'tv2NewsState/getNews',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/adminOptions/tv2`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            const data = response.data.rss.channel.item;
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    news: [],
    error: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
};

const tv2NewsSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNews.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getNews.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.news = action.payload;
            })
            .addCase(getNews.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred'; 
            });
    },
});

export default tv2NewsSlice.reducer;